export const toUrlSafe = (s: string): string => s.replace(/\+/g, '-').replace(/\//g, '_');
export const fromUrlSafe = (s: string): string => {
    let str = s.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) {
        str += '=';
    }
    return str;
};

export const encodeText = (text: string, urlSafe: boolean, withPadding: boolean): string => {
    if (!text) return '';
    try {
        let encoded = btoa(unescape(encodeURIComponent(text)));
        if (urlSafe) {
            encoded = toUrlSafe(encoded);
        }
        if (!withPadding) {
            return encoded.replace(/=+$/, '');
        }
        return encoded;
    } catch {
        return '';
    }
};

export const decodeText = (text: string, urlSafe: boolean): string => {
    if (!text) return '';
    // Use a lenient approach to handle both url-safe and standard inputs
    let processed = text.replace(/-/g, '+').replace(/_/g, '/');
    
    while (processed.length % 4) {
        processed += '=';
    }

    if (!/^[A-Za-z0-9+/=_-]*$/.test(text)) {
        throw new Error('Invalid Base64 characters');
    }
    const decoded = decodeURIComponent(escape(atob(processed)));
    return decoded;
};

export const getByteCount = (str: string): number => {
    return new Blob([str]).size;
};